import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function Login() {
  const [clientId, setClientId] = useState("xWqz8JEGKoeTGGtV2HytmybLhHyfz7yB");
  const [clientSecret, setClientSecret] = useState("p-YKGhptrTs2980A1AfQFm6l0aGWokRODarN1t2A");
  const [message, setMessage] = useState("");
  const [storeId, setStoreId] = useState("065896b1-9b82-415c-a178-46273b642374"); // Pre-filled

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage("Logging in...");

    const url = "/oauth/v2/token"; // Proxy handles the base URL

    const body = new URLSearchParams({
      client_id: clientId,
      client_secret: clientSecret,
      grant_type: "client_credentials",
      scope: "eats.store eats.store.status.write",
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: body.toString(),
      });

      if (response.ok) {
        const data = await response.json();
        const { access_token } = data;

        localStorage.setItem("accessToken", access_token);
        localStorage.setItem("storeId", storeId); // Save the pre-filled storeId
        setMessage("Login successful!");

        navigate("/categories"); // Redirect to categories page
      } else {
        setMessage("Login failed. Please check your credentials.");
      }
    } catch (error) {
      console.error("Error during login:", error);
      setMessage("An error occurred. Please try again later.");
    }
  };

  return (
    <div>
      <h2>Login</h2>
      <form onSubmit={handleLogin}>
        <div>
          <label>Client ID:</label>
          <input
            type="text"
            value={clientId}
            onChange={(e) => setClientId(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Client Secret:</label>
          <input
            type="password"
            value={clientSecret}
            onChange={(e) => setClientSecret(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Store ID:</label>
          <input
            type="text"
            value={storeId} // Pre-filled store ID
            onChange={(e) => setStoreId(e.target.value)}
            required
          />
        </div>
        <button type="submit">Login</button>
      </form>
      <p>{message}</p>
    </div>
  );
}

export default Login;
